import api from '@/services/api-service';
import RestResource from '@/services/resources/restResource';
import { ReportTypes } from '@/core/enums';

export class ReportsResource extends RestResource {
    /**
     *
     * @param {ApiClient} apiClient
     */
    constructor(apiClient) {
        super(apiClient, 'reports');
    }

    getEmbedInfo(reportType) {
        let reportParam = '';

        switch (reportType) {
        case ReportTypes.ShippedOrderDetails:
            reportParam = '/shipped-order-details';
            break;
        case ReportTypes.ShippedOrderCost:
            reportParam = '/shipped-order-cost';
            break;
        case ReportTypes.ReceivingDetails:
            reportParam = '/receiving-details';
            break;
        case ReportTypes.ReturnDetails:
            reportParam = '/return-details';
            break;
        case ReportTypes.InventoryActivity:
            reportParam = '/inventory-activity';
            break;
        case ReportTypes.ShipmentTracking:
            reportParam = '/shipment-tracking';
            break;
        case ReportTypes.MonthlyItemsShipped:
            reportParam = '/monthly-items-shipped';
            break;
        case ReportTypes.MonthlyShippingSummary:
            reportParam = '/monthly-shipping-summary';
            break;
        case ReportTypes.DailyReturns:
            reportParam = '/daily-returns';
            break;
        case ReportTypes.DeletedOrders:
            reportParam = '/deleted-orders';
            break;
        case ReportTypes.DailyInventoryWLot:
            reportParam = '/daily-inventory-wlot';
            break;
        case ReportTypes.DashboardFulfillment:
            reportParam = '/orders-fulfillment';
            break;
        case ReportTypes.ItemQtyFulfillment:
            reportParam = '/items-qty-fulfillment';
            break;
        case ReportTypes.Top10FulfilledItems:
            reportParam = '/top-10-fulfillment-items';
            break;
        case ReportTypes.AvgDaysFulfillBusinessOrders:
            reportParam = '/avg-days-fulfill-business-orders';
            break;
        case ReportTypes.FulfilledOrdersPerWarehouse:
            reportParam = '/fulfilled-orders-per-warehouse';
            break;
        case ReportTypes.OrdersSubmitted:
            reportParam = '/orders-submitted';
            break;
        case ReportTypes.PercentConsumerOrdersFulfilled:
            reportParam = '/percent-consumer-orders-fulfilled';
            break;
        case ReportTypes.ConsumerOrdersFulfillmentSLA:
            reportParam = '/consumer-orders-fulfillment-SLA';
            break;
        case ReportTypes.PercentExistingItemsReceivingOnTime:
            reportParam = '/percent-existing-items-receiving-on-time';
            break;
        case ReportTypes.DomAverageActualWeight:
            reportParam = '/domestic-average-actual-weight';
            break;
        case ReportTypes.DomAverageRatedWeight:
            reportParam = '/domestic-average-rated-weight';
            break;
        case ReportTypes.DomOrdersShippedPerMethod:
            reportParam = '/domestic-orders-shipped-per-method';
            break;
        case ReportTypes.DomOrdersShippedPerZone:
            reportParam = '/domestic-orders-shipped-per-zone';
            break;
        case ReportTypes.IntAverageActualWeight:
            reportParam = '/international-average-actual-weight';
            break;
        case ReportTypes.IntAverageRatedWeight:
            reportParam = '/international-average-rated-weight';
            break;
        case ReportTypes.IntTop5Countries:
            reportParam = '/international-top-countries';
            break;
        case ReportTypes.IntOrdersShippedPerMethod:
            reportParam = '/international-orders-shipped-per-method';
            break;
        case ReportTypes.DomOrdersShippedHeatMap:
            reportParam = '/domestic-orders-shipped-heat-map';
            break;
        case ReportTypes.FullyReceivedASNs:
            reportParam = '/fully-received-asns';
            break;
        case ReportTypes.PartiallyReceivedASNs:
            reportParam = '/partially-received-asns';
            break;
        case ReportTypes.ReceivedItemsAndQuantities:
            reportParam = '/received-items-and-quantities';
            break;
        case ReportTypes.PercentNewItemsReceivedOnTime:
            reportParam = '/percent-new-items-received-on-time';
            break;
        case ReportTypes.ExpectedVsReceivedQuantityASNs:
            reportParam = '/expected-vs-received-quantity-per-asn';
            break;
        case ReportTypes.Top10ReceivedItems:
            reportParam = '/top-10-received-items';
            break;
        case ReportTypes.ReceivedQuantityPerWarehouse:
            reportParam = '/received-quantity-per-warehouse';
            break;
        case ReportTypes.InventoryAdjustments:
            reportParam = '/inventory-adjustments';
            break;
        case ReportTypes.ReturnItemsAndQuantities:
            reportParam = '/return-items-and-quantities';
            break;
        case ReportTypes.PercentItemsReturnedToStock:
            reportParam = '/percent-items-returned-to-stock';
            break;
        case ReportTypes.Top10ReturnedItems:
            reportParam = '/top-10-items-returned';
            break;
        case ReportTypes.ReturnedOrders:
            reportParam = '/returned-orders';
            break;
        case ReportTypes.ReturnedItemsPerReason:
            reportParam = '/returned-items-per-reason';
            break;
        case ReportTypes.ReturnedQuantitiesPerWarehouse:
            reportParam = '/returned-quantities-per-warehouse';
            break;
        case ReportTypes.DailyReceiving:
            reportParam = '/daily-receiving';
            break;
        default:
            reportParam = `?reportType=${reportType}`;
        }

        return this.api.get(`${this.endpoint}${reportParam}`);
    }

    getReportDownloadData(reportType, slicerSearchValues, callNumber) {
        const data = {
            pageSize: 50000,
            page: callNumber,
            reportType,
            selectedFilters: JSON.stringify(slicerSearchValues),
        };
        return this.api.post(`${this.endpoint}/getReportDownloadData`, data);
    }

    getReportDownloadFileURL() {
        return `${this.api.baseURL}/${this.endpoint}/getReportDownloadFile`;
    }
}

export default new ReportsResource(api);
